import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Row } from 'reactstrap';
import getCourts from '../actions/courtsActions';
import { formatDateForSessionCard } from '../utils/other';
import HeaderContainerTemplate from '../containers/templates/HeaderContainerTemplate';
import QuickBookingCourts from '../containers/QuickBookingCourts';
import CourtsFiltersContainer from '../containers/CourtsFiltersContainer';
import CourtCard from '../components/CourtCard';
import i18n from '../utils/i18n';
import { setPendingBookingCourtEventId } from '../actions/pendingBookingActions';
import { courtsFiltersModes, idsNames } from '../utils/constants';
import { initCourtFilters, setCourtsFilters } from '../actions/filterActions';
import { resetScrollToId } from '../actions/scrollToActions';
import { getUserData } from '../actions/userActions';
import './styles/CourtsScreen.scss';

class Courts extends React.Component {
  componentDidMount() {
    this.props.getCourts(this.props.courtsFilters);
    this.props.initCourtFilters();
    this.props.getUserDataFunc();
  }

  componentWillUnmount() {
    this.props.setPendingBookingCourtEventId(null);
    this.props.resetScrollToId();
  }

  render() {
    const courtsAvailable = !this.props.fetchingCourts && this.props.courts;
    const courtsEmpty = this.props.courts && this.props.courts.length === 0;

    return (
      <HeaderContainerTemplate>
        <Container className="courts-screen-wrapper">
          <div className="courts-screen-inner">
            <div className="courts-header-filters">
              <div className="header2 courts-header">
                {i18n.t('courtsScreen.COURTS')}
              </div>
              <div className="hidden-mobile">
                <CourtsFiltersContainer
                  courtsFiltersMode={ courtsFiltersModes.FULL }
                />
              </div>
              <div className="visible-mobile">
                <CourtsFiltersContainer
                  courtsFiltersMode={ courtsFiltersModes.PART }
                />
              </div>
              {this.props.fetchingCourts && (
                <div className="fetching-courts">
                  {i18n.t('courtsScreen.FETCHING_COURTS')}
                </div>
              )}
            </div>
            <Row>
              {courtsAvailable && (
                <div className="courts-cards-container">
                  {this.props.courts.map(court => (
                    <QuickBookingCourts
                      id={ idsNames.COURT_ID_PREFIX + String(court.id) }
                      event={ court }
                      key={ court.id }
                    >
                      <CourtCard
                        availableSpaces={ court.available_courts }
                        time={ formatDateForSessionCard(
                          court.start_time,
                          court.event_date
                        ) }
                        clubName={ court.venue_club_name }
                        clubAddress={ court.venue_address }
                        courtType={ court.court_type_name }
                        bookingAvailabilityStatus={
                          court.booking_availability_status
                        }
                      />
                    </QuickBookingCourts>
                  ))}
                  {courtsEmpty && (
                    <div className="no-data-with-criteria">
                      {i18n.t('courtsScreen.NO_COURTS_MATCH_YOUR_CRITERIA')}
                    </div>
                  )}
                </div>
              )}
            </Row>
          </div>
        </Container>
      </HeaderContainerTemplate>
    );
  }
}

Courts.propTypes = {
  getCourts: PropTypes.func.isRequired,
  courts: PropTypes.arrayOf(
    PropTypes.shape({
      available_spaces: PropTypes.number
    })
  ),
  fetchingCourts: PropTypes.bool,
  setPendingBookingCourtEventId: PropTypes.func.isRequired,
  initCourtFilters: PropTypes.func.isRequired,
  courtsFilters: PropTypes.arrayOf(PropTypes.shape({})),
  resetScrollToId: PropTypes.func.isRequired,
  getUserDataFunc: PropTypes.func.isRequired
};

Courts.defaultProps = {
  courts: [],
  fetchingCourts: false,
  courtsFilters: []
};

const mapStateToProps = state => ({
  courts: state.courts.data,
  fetchingCourts: state.courts.loading,
  courtsFilters: state.filter.courtsFilters
});

const mapDispatchToProps = dispatch => ({
  getCourts: filters => dispatch(getCourts(filters)),
  setPendingBookingCourtEventId: id =>
    dispatch(setPendingBookingCourtEventId(id)),
  initCourtFilters: () => dispatch(initCourtFilters()),
  setCourtsFilters: filters => dispatch(setCourtsFilters(filters)),
  resetScrollToId: () => dispatch(resetScrollToId()),
  getUserDataFunc: () => dispatch(getUserData())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Courts);



// WEBPACK FOOTER //
// ./src/scenes/Courts.js